import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('More', function (props) {
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "12",
    cy: "24",
    r: "3",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "3",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "36",
    cy: "24",
    r: "3",
    fill: "currentColor"
  }));
});